var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindowData = function SvgWindowData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.45 13.067a5.867 5.867 0 1 1 0 11.733 5.867 5.867 0 0 1 0-11.733m0 0v5.866l4.159 4.146m6.27-9.36h3.912m-3.911 5.214h3.91m-3.91 5.215h3.91M1.334 8.83h29.334M3.289 2.963H28.71s1.956 0 1.956 1.955v22.163s0 1.956-1.956 1.956H3.29s-1.956 0-1.956-1.956V4.918s0-1.955 1.956-1.955",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgWindowData;